'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidGlobe = function IoAndroidGlobe(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2z m-1.8 30c0.5-1.1 1.7-2.2 0.7-3-0.7-0.6-1.3-1.1-1.8-1.7-0.2-0.1-0.9-1.5-0.7-1.8 0.3-0.7 0.4-1 0.6-1.8 0.2-1-0.3-1.3-1-1.8-1.2-0.7-2.3-1.7-3.4-2.6-0.5-0.4-1.3-0.8-1.6-1.5s-0.3-1.6-0.7-2.2c-1.1-1.5-1-2.6-0.8-4.5 0-0.6-0.1-1.3-0.2-2-2.2 2.5-3.3 5.7-3.3 9.1 0 3.8 1.5 7.2 4.1 9.8 2.3 2.3 5.1 3.6 8.1 4z m11.6-4c1.8-1.8 3-3.9 3.7-6.4-0.7 0.1-1.5-0.1-1.5-0.1s-1.7-1.9-1.8-3.5c-0.2-1.8 0-3.1-0.2-4.5-0.3-1.2-1.6-2.4-2.2-3.6-0.5-1.1-1-2.2-1.5-3.3 0.1 0.1 0.4 0.2 0.5 0.3 0.4-0.1 0.8-0.2 1.1-0.2-1.8-1.2-3.8-1.9-5.9-2.3v0.7l0.3 0.7-1.1 1-0.7-0.2-0.8-0.8-0.8-1-1.1-0.4c-1.2 0.2-2.4 0.6-3.5 1.1v0.5c0.6-0.2 1.3-0.4 1.8-0.6 0.3-0.1 1 0.5 1.3 0.7-0.3 0.4-1.7 1.2-1.7 1.6 0 0.2 0.5 0.5 0.5 0.8 0 0.5-0.1 0.9-0.1 1.3 0.3-0.2 1.6-1.6 1.7-1.6 1.1-0.2 2.8 1.5 2.9 2s-1.7 1.9-2.5 2.7c-0.7 0.6-2 0.9-1.6 1.9 0.2 0.3 0.8 1.5 0.4 1.8-0.5 0.4-1.1-0.7-1.3-0.9-0.7-0.8-2.1-0.5-3-0.5 0 1.3-0.1 2.4 1.2 3.3 1.1 0.9 2.3 2 3.6 2.6 1 0.5 2.8-0.6 3.7 0.1 1.3 0.8 2.3 1.6 3.7 2.2 0.6 0.3 2.6 1.6 2 2.5-0.4 0.6-0.8 1.1-1.1 1.8s-1 1.5-1.5 1.9c-0.7 0.5-1.3 1.3-1.7 2.3 2.7-0.6 5.2-1.8 7.2-3.9z' })
        )
    );
};

exports.default = IoAndroidGlobe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-globe.js
// module id = 1894
// module chunks = 0